// axios请求拦截
import Vue from 'vue'
import router from '@/router';
import { store } from '@/store';
import Axios from 'axios';

const req = Axios.create({
    // baseURL:'http://localhost:3000' // 跨域
    baseURL: '/api' // 实例独特的表示，走代理解决跨域
});
// 拦截器 = 公共行为: 请求loading 响应关闭loading
// 响应的错误常规处理 401 => 无权访问, 路由跳转到401页面
// 请求时 如果有token， 自动添加到请求头，响应时自动存储token 
req.interceptors.response.use((response) => {
    // response:{ data,config:{ headers }  }
    if (response && response.data) {
        let res = response.data

        let status = ''
        // if (!res.status) {
        //     console.log('错误返回',res)
        // }
        if (res.status) {
            status = res.status
        } else {
            status = res.code
        }
        const isLoginApi = response.config.url.includes('/login');
        if (status == 200 || status == 0) {
            if (res.data && res.data.token) {
                // 保存到本地存储: sessionStorage, localStorage
                store.commit('user/SET_TOKEN', 'Bearer ' + res.data.token);
            }
        } else if (!isLoginApi) {
            if (status == 401) {
                // 清空缓存
                store.commit('user/REMOVE_TOKEN');
                // alert(response.data.message)
                Vue.prototype.$confirmError('token失效，请重新登录！');
                router.replace('/login')
            }
            else if (status == 40003) { }
            else {
                // alert(response.data.message)
                if (response.data?.message)
                    Vue.prototype.$confirmError(response.data.message);
            }
        }
    }
    // 处理响应的业务异常
    return response;
}, (err) => {
    // 4xx 5xx异常
    // 非业务范畴的通用异常提示
    console.log('响应异常:', err)
    if (err.response && err.response.status) {
        const status = err.response.status
        if (status === 500) {
            Vue.prototype.$confirmError('服务器内部错误，请稍后重试！');
        } else if (status == 401) {
            // 清空缓存
            store.commit('user/REMOVE_TOKEN');
            sessionStorage.clear()
            // alert('登陆错误，请重新登陆！')
            Vue.prototype.$confirmError('token失效，请重新登陆！');
            router.replace('/login')
        } else if (status == 403) {
            // 清空缓存
            store.commit('user/REMOVE_TOKEN');
            sessionStorage.clear()
            // alert('登录超时，请重新登录！')
            Vue.prototype.$confirmError('登录超时，请重新登录！');
            router.replace('/login')
        } else {
            // alert(err.response.statusText)
            Vue.prototype.$confirmError(err.response.statusText);
        }

    }

})

// 请求使用token
req.interceptors.request.use((config) => {
    // 在请求头中携带token
    const token = store.getters['user/getToken'];
    if (token) {
        config.headers.Authorization = token;
    }
    // console.log('路由拦截', config.url)
    // 添加/admin前缀到baseURL
    if (config.url.includes('/app')) {
        // 如果请求的URL已经包含/admin，则不需要添加
        return config;
    }
    if (config.baseURL) {
        config.baseURL = config.baseURL.replace(/\/$/, '') + '/admin'; // 确保不会添加重复的斜杠
    } else {
        config.baseURL = '/admin'; // 如果原本没有baseURL，则直接设置
    }
    return config;
});
export default req;
